export const DICTIONARIES = {
  SET_MODAL_POPUP: 'SET_MODAL_POPUP',
  CLOSE_MODAL_POPUP: 'CLOSE_MODAL_POPUP',
  RESET_ALL: 'RESET_ALL'
};
